import { TFC } from '@ftd/types'
import { Anchor as MantineAnchor, type AnchorProps } from '@mantine/core'
import LinkNext, { LinkProps } from 'next/link'

type TProps = {
  target?: string
  rel?: string
} & LinkProps &
  AnchorProps

export const Link: TFC<TProps> = ({ children, target = '_self', rel, ...props }) => (
  <MantineAnchor component={LinkNext} {...props} target={target} rel={rel} passHref>
    {children}
  </MantineAnchor>
)
